export const getDateWithTimezoneOffset = (date: string) => {
  const currentDate = date ? new Date(date) : new Date();

  currentDate.setTime(currentDate.getTime() + currentDate.getTimezoneOffset() * 60000);

  return currentDate;
};
